import React, { Component } from 'react';
import { connect }          from 'react-redux';
import {Link}               from 'react-router-dom'
import {OverlayTrigger,Tooltip} from 'react-bootstrap';

class menu_sidebar extends Component {

    constructor(props){
        super(props);

        this.state = {checkSelect:false}
    }

    renderLisMenu(){
          
            const nomeMenu = [
                // {
                //  nome : 'Home',
                //  icon : 'icon-icones-hud-01',
                //  menu : `${this.props.menu.home}`
                // },
                // {
                //  nome : 'Batalha',
                //  icon : 'icon-icones-hud-04',
                //  menu : `${this.props.menu.batalha.professor.home}`
                // },  
                {
                 nome : 'Comunicação',
                 icon : 'icon-icones-hud-07',
                 menu : `${this.props.menu.equipe.professor.home}`
                },  
                // {
                //  nome : 'Desafios',
                //  icon : 'icon-icones-hud-15',
                //  menu : `${this.props.menu.desafios.home}`
                // },
                {
                 nome : 'Missões',
                 icon : 'icon-icones-hud-12',
                 menu : `${this.props.menu.missao.home}`
                },  
                // {
                //  nome : 'Timeline Turma',
                //  icon : 'icon-icones-hud-09',
                //  menu : `${this.props.menu.turma.professor.timeline_turma}`
                // },  
                {
                 nome : 'Relatório',
                 icon : 'icon-icones-hud-11',
                 menu : `${this.props.menu.relatorio.home}`
                }
               ];

                const lista = nomeMenu.map((elem,i)=>{
                    const tooltip = (<Tooltip id="tooltip"><strong>{elem.nome}</strong></Tooltip>);
                return ( <li key={i}>
                            <OverlayTrigger placement="right" overlay={tooltip}>
                              <Link to={{ pathname:elem.menu,state: { Select: null }}} >{elem.nome} <span className={`sub_icon ${elem.icon}`}></span></Link>
                            </OverlayTrigger>
                        </li>
                        );
               });
             
               return lista;
        

    }


    render() {
     
        return (
            <div>
                {this.renderLisMenu()}
            </div>
        );
    }
}
function mapStateToProps(state){

    return {
            menu : state.configReducer.menu,
        }

}

export default connect(mapStateToProps,{})(menu_sidebar);


// WEBPACK FOOTER //
// ./src/components/professor/menu/menu_sidebar.js